<template>
  <v-flex xs12>
    <confirmation-header-text v-if="paid || total > 0 || costExempted" class="ml-2" icon="mdi-alpha-p-box"
                              text="Payment Details"/>
    <!--    {{ total }}-->
    <!--    {{ payment_detail }}<br>-->
    <!--    {{ payment_detail.ebp_no }}-->
    <span v-if="!paid">
            <v-layout class="ml-2" row v-if="payment_detail" wrap>
                <v-flex v-if="voucherNumber" xs3>
                    <list-item-detail :sub_title="voucherNumber"
                                      title="RMIS Voucher number"/>
                </v-flex>

                <v-flex v-if="payment_detail.amount > 0" xs3>
                    <list-item-detail :sub_title="payment_detail.amount"
                                      title="Visa Fee(USD)"/>
                </v-flex>
                <v-flex v-if="payment_detail.border_penalty > 0" xs3>
                    <list-item-detail :sub_title="payment_detail.border_penalty"
                                      title="Border Penalty-10.4 (USD)"/>
                </v-flex>

              <!--                {{payment_detail}}-->
                <v-flex v-if="payment_detail.late_stay_cost > 0" xs3>
                    <list-item-detail :sub_title="payment_detail.late_stay_cost"
                                      title="Late Fee (USD)"/>
                </v-flex>
                <v-flex v-if="payment_detail.transfer_cost > 0" xs3>
                    <list-item-detail :sub_title="payment_detail.transfer_cost"
                                      title="Visa Transfer Fee (USD)"/>
                </v-flex>

                  <v-flex v-if="payment_detail.penalty_cost>0" xs3>
                    <list-item-detail :sub_title="payment_detail.penalty_cost"
                                      title="Penalty-10.4 (USD)"/>
                </v-flex>
                <v-flex v-if="payment_detail.penalty_npr>0" xs3>
                    <list-item-detail :sub_title="payment_detail.penalty_npr"
                                      title="Penalty-10.4 (NPR)"/>
                </v-flex>
                <v-flex v-if="costExempted" xs3>
                    <list-item-detail :sub_title="payment_detail.exempt_cost"
                                      title="Exempted Amount(USD)"/>
                </v-flex>

                  <v-flex v-if="total > 0 || costExempted" xs3>
                    <list-item-detail :sub_title="total"
                                      title="Total cost(USD)"/>
                </v-flex>
            </v-layout>
        </span>
    <span v-else>

            <v-layout class="pl-3" row
                      v-if="payment_detail.source && payment_detail.source.toLowerCase() === 'online'" wrap>
                <v-flex sm3 xs12>
                    <list-item-detail sub_title="Online payment"
                                      title="Payment method"/>
                </v-flex>
                <v-flex sm3 xs12>
                    <list-item-detail :sub_title="payment_detail.transaction_detail.amount"
                                      title="Amount(USD)"/>
                </v-flex>
                <v-flex sm3 xs12>
                    <list-item-detail :sub_title="payment_detail.transaction_detail.ipay_out__ipg_txn_id"
                                      title="Transaction code"/>
                </v-flex>
                <v-flex sm3 xs12>
                    <list-item-detail :sub_title="payment_detail.transaction_detail.ipay_out__mer_ref_id"
                                      title="Merchant Reference id"/>
                </v-flex>
                <v-flex v-if="payment_detail.amount > 0" xs3>
                    <list-item-detail :sub_title="payment_detail.amount"
                                      title="Visa Fee(USD)"/>
                </v-flex>

                
                <v-flex v-if="total > 0 || costExempted" xs3>
                    <list-item-detail :sub_title="total"
                                      title="Total cost(USD)"/>
                </v-flex>
            </v-layout>

            <v-layout class="pl-6" row v-else-if="payment_detail.ebp_no" wrap>
                    <v-flex sm3 xs12>
                        <list-item-detail sub_title="Malenika" title="Payment method"/>
                    </v-flex>
                    <v-flex sm3 xs12>
                        <list-item-detail :sub_title="payment_detail.voucher_number"
                                          title="Voucher Number"/>
                    </v-flex>
                    <v-flex sm3 xs12 v-if="payment_detail.bank_name">
                        <list-item-detail :sub_title="payment_detail.bank_name"
                                          title="Bank name"/>
                    </v-flex>
                    <v-flex v-if="payment_detail.amount > 0" xs3>
                    <list-item-detail :sub_title="payment_detail.amount"
                                      title="Visa Fee(USD)"/>
                </v-flex>
                    <v-flex sm3 xs12 v-if="payment_detail.office_name">
                        <list-item-detail :sub_title="payment_detail.office_name"
                                          title="Office name"/>
                    </v-flex>
                    <v-flex sm3 xs12 v-if="payment_detail.paid_at">
                        <list-item-detail :sub_title="payment_detail.paid_at"
                                          title="Paid at"/>
                    </v-flex>
                    <v-flex v-if="total > 0 || costExempted" xs3>
                    <list-item-detail :sub_title="total"
                                      title="Total cost(USD)"/>
                </v-flex>
                    <v-flex sm3 xs12 v-if="payment_detail.code">
                        <list-item-detail :sub_title="payment_detail.ebp_no"
                                          title="EBP No"/>
                    </v-flex>

                    <v-flex sm3 xs12 v-if="payment_detail.revenue_head">
                        <list-item-detail :sub_title="payment_detail.revenue_head"
                                          title="Revenue head"/>
                    </v-flex>
                    <v-flex sm3 xs12>
                        <list-item-detail :sub_title="payment_detail.total_amount"
                                          title="Total amount(NPR)"/>
                    </v-flex>
               <v-flex sm3 xs12 v-if="type && total_cost">
                        <list-item-detail :sub_title="total_cost"
                                          title="Total amount(USD)"/>
                    </v-flex>
                    <v-flex sm12 xs12>
                        <list-item-detail :sub_title="payment_detail.payment_description"
                                          title="Payment description"/>
                    </v-flex>
            </v-layout>
            <v-layout class="px-6" row v-else wrap>
                <v-flex sm3 xs12><list-item-detail sub_title="Manual" title="Payment method"/></v-flex>
                <v-flex sm3 xs12>
                    <list-item-detail :sub_title="payment_detail.amount" title="Total amount (USD)"/></v-flex>
                <v-flex sm3 xs12 v-if="type">
                    <list-item-detail :sub_title="payment_detail.amount_npr" title="Total amount (NPR)"/></v-flex>
                 <v-flex sm3 xs12 v-if="!type">
                    <list-item-detail
                        :sub_title="visa_amount"
                        title="Visa amount(USD)"/>
                </v-flex>
                 <v-flex sm3 v-if="payment_detail.late_stay_cost > 0" xs12>
                    <list-item-detail :sub_title="payment_detail.late_stay_cost"
                                      title="Late stay cost (USD)"/>
                </v-flex>
                   <v-flex sm3 v-if="payment_detail.penalty_cost > 0" xs12>
                    <list-item-detail :sub_title="payment_detail.penalty_cost"
                                      title="Penalty amount (USD)"/>
                </v-flex>
               <v-flex v-if="payment_detail.penalty_npr>0" xs3>
                    <list-item-detail :sub_title="payment_detail.penalty_npr"
                                      title="Penalty amount (NPR)"/>
                </v-flex>
                <v-flex sm3 v-if="payment_detail.exempt_cost > 0" xs12>
                    <list-item-detail :sub_title="payment_detail.exempt_cost"
                                      title="Exempt cost (USD)"/>
                </v-flex>
                <v-flex sm3 xs12>
                    <list-item-detail :sub_title="payment_detail.bank" title="Bank/Office name"/>
                </v-flex>
                <v-flex sm3 xs12>
                    <list-item-detail :sub_title="payment_detail.invoice_number" title="Invoice number"/>
                </v-flex>
            </v-layout>
        </span>
  </v-flex>
</template>
<script>
import ListItemDetail from "../components/ListItemDetail";
import ConfirmationHeaderText from "../components/ConfirmationHeaderText";

export default {
  name: "PaymentDetail",
  props: ['payment_detail', 'paid', 'voucherNumber', 'costExempted', 'type','total_cost'],
  computed: {
    total() {
      let {
        late_stay_cost,
        amount,
        penalty_cost,
        exempt_cost,
        transfer_cost,
        border_penalty,
        rate_amount
      } = this.payment_detail;
      rate_amount = rate_amount != undefined ? parseFloat(rate_amount) : 0;
      late_stay_cost = late_stay_cost != undefined ? parseFloat(late_stay_cost) : 0;
      penalty_cost = penalty_cost != undefined ? parseFloat(penalty_cost) : 0;
      exempt_cost = exempt_cost != undefined ? parseFloat(exempt_cost) : 0;
      transfer_cost = transfer_cost != undefined ? parseFloat(transfer_cost) : 0;
      border_penalty = border_penalty != undefined ? parseFloat(border_penalty) : 0;
      const total = rate_amount + late_stay_cost + parseFloat(amount) + penalty_cost - exempt_cost + transfer_cost + border_penalty;
      return total.toFixed(2)
    },
    visa_amount() {
      let {amount, late_stay_cost, penalty_cost, exempt_cost} = this.payment_detail;
      late_stay_cost = late_stay_cost != undefined ? parseFloat(late_stay_cost) : 0;
      penalty_cost = penalty_cost != undefined ? parseFloat(penalty_cost) : 0;
      exempt_cost = exempt_cost != undefined ? parseFloat(exempt_cost) : 0;
      const visa_amount = amount - late_stay_cost - penalty_cost + exempt_cost
      return visa_amount.toFixed(2)
    }
  }
  ,
  components: {
    ListItemDetail,
    ConfirmationHeaderText,
  },
}
</script>
